module.exports = __webpack_public_path__ + "media/images/lp/1/donation3-title-sp-395a5b3d9887c058be78b3c704c6520a.png";